<template>
    <img src="../../../../assets/image/live/back.png" class="room-back" @click="back"/>
</template>

<script>
export default {
  props: {
  },
  data () {
    return {}
  },
  methods: {
    back () {
      this.$emit('quitGroup')
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
    .room-back {
        width: 1.6rem;
        height: 1.6rem;
    }
</style>
